import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Router, ActivatedRoute} from '@angular/router';
import { PopupService } from '@/services/app/popup.service';
import { PopupResult } from '@/utility/popup-util';
import { PopupInstructionsComponent } from '@/utility/popup-tutorial.component';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule, RouterModule, PopupInstructionsComponent],
    template: `
    <div class="embed-redirect flex flex-col" *ngIf="!popupBlocked">
      <p>Redirecting to full application...</p>
      <p style="margin-top: 0.5rem;">
        If nothing happens, 
        <button type="button" (click)="retryOpen()" class="btn-like">Open manually</button>
      </p>
    </div>

    <div class="embed-redirect" *ngIf="popupBlocked">
  <app-popup-instructions
    [siteToAllow]="siteToAllow"
    [fallbackHref]="appUrl"
    (retry)="retryOpen()">
  </app-popup-instructions>
</div>
  `,
  styles: [`
    .embed-redirect {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Arial, sans-serif;
      color: #666;
      text-align: center;
      padding: 1rem;
    }
    .btn-like {
      border: 1px solid #aaa;
      background: #f7f7f7;
      padding: 0.4rem 0.8rem;
      border-radius: 6px;
      cursor: pointer;
    }
    .btn-like:hover { background: #eee; }
  `]
})
export class EmbedComponent implements OnInit {
  popupBlocked = false;
  appUrl = '';
  siteToAllow = 'app.hubspot.com'; // or location.host if same-site

  constructor(private popup: PopupService) {}

  ngOnInit() {
    const currentUrl = window.location.href;
    this.appUrl = currentUrl.replace('/embed', '/app');
    this.tryOpenAndMaybeNotify();
  }

  retryOpen() {
    this.tryOpenAndMaybeNotify();
  }

  private tryOpenAndMaybeNotify() {
    // crank timeout to 6s while debugging
    this.popup.openAndConfirm(this.appUrl, { debug: true, timeoutMs: 6000 }).then((ok) => {
      console.debug('[embed] openAndConfirm resolved', { ok });
      if (ok) {
        this.popupBlocked = false;
        this.notifyHubSpotDone();
      } else {
        this.popupBlocked = true;
      }
    });
  }

  private notifyHubSpotDone() {
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ action: 'DONE' }, '*');
      }
    } catch {}
  }
}